import { apiGet } from "../client";
import { useQuery } from "@tanstack/react-query";
import type { IExamSet } from "./types";

export const apiGetExamSet = async (id: string) => {
  return apiGet<IExamSet>(`/exam_sets/${id}`);
};

export const useQueryGetExamSet = (id: string, options = {}) => {
  return useQuery({
    queryKey: ["exam_set", id],
    queryFn: () => apiGetExamSet(id),
    select: (response) => response.data,
    enabled: !!id,
    ...options,
  });
};

export default useQueryGetExamSet;
